export default class Srt {
  constructor (stream) {
    this.stream = stream
    this.id = this.stream.member.uuid
    this.srts = {}
  }

  parseIpPort (input) {
    const parts = input.split('-')
    const ip = parts.slice(0, 4).join('.')
    const port = parts[4]
    return `${ip}:${port}`
  }

  update (srt) {
    if (srt.caller) {
      const caller = this.parseIpPort(srt.caller)

      if (!this.srts[caller]) {
        this.srts[caller] = {}
      }

      this.srts[caller].packetsSentLost = Number(srt.packetsSentLost) || 0
      this.srts[caller].packetsRetransmitted = Number(srt.packetsRetransmitted) || 0
      this.srts[caller].sendRate = Number(srt.sendRate) || 0 // Mbit/s
      this.srts[caller].bandwidth = Number(srt.bandwidth) || 0 // Mbit/s
      this.srts[caller].rtt = Number(srt.rtt) // ms
    }
  }
}
